import "./registration-actions.scss";
import { Button } from "primereact/button";
import { GetRegistrationModel } from "@factory/model/query-model-registration";

/* eslint-disable-next-line */
export interface RegistrationActionsProps {
  registration: GetRegistrationModel;
  onUpdateClick: () => void;
  onApproveClick: () => void;
  onDeclineClick: () => void;
  isLoading?: boolean;
}

export function RegistrationActions({
  registration,
  onUpdateClick,
  onApproveClick,
  onDeclineClick,
  isLoading = false,
}: RegistrationActionsProps) {
  return (
    <div id="RegistrationActions" className="registration-actions">
      <div className="mt-6 space-y-2">
        <Button
          label="Update Information"
          icon="pi pi-pencil"
          onClick={onUpdateClick}
          className="w-full p-button-sm"
          severity="secondary"
          outlined
        />

        {registration.status === "PENDING" && (
          <>
            <Button
              label="Approve"
              icon="pi pi-check"
              loading={isLoading}
              onClick={onApproveClick}
              className="w-full p-button-sm"
            />

            <Button
              label="Decline"
              icon="pi pi-times"
              loading={isLoading}
              onClick={onDeclineClick}
              className="w-full p-button-sm"
              severity="danger"
            />
          </>
        )}
      </div>
    </div>
  );
}

export default RegistrationActions;
